var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_12519_21302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.92969 3.51562H6.05469C6.37828 3.51562 6.64062 3.25328 6.64062 2.92969C6.64062 2.60609 6.37828 2.34375 6.05469 2.34375H2.92969C2.60609 2.34375 2.34375 2.60609 2.34375 2.92969C2.34375 3.25328 2.60609 3.51562 2.92969 3.51562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.92969 5.85938H6.05469C6.37828 5.85938 6.64062 5.59703 6.64062 5.27344C6.64062 4.94984 6.37828 4.6875 6.05469 4.6875H2.92969C2.60609 4.6875 2.34375 4.94984 2.34375 5.27344C2.34375 5.59703 2.60609 5.85938 2.92969 5.85938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.92969 8.20312H6.05469C6.37828 8.20312 6.64062 7.94078 6.64062 7.61719C6.64062 7.29359 6.37828 7.03125 6.05469 7.03125H2.92969C2.60609 7.03125 2.34375 7.29359 2.34375 7.61719C2.34375 7.94078 2.60609 8.20312 2.92969 8.20312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.8516 0H2.14844C0.963789 0 0 0.963789 0 2.14844V17.8516C0 19.0362 0.963789 20 2.14844 20H17.8516C19.0362 20 20 19.0362 20 17.8516V2.14844C20 0.963789 19.0362 0 17.8516 0ZM7.8125 18.8281H2.14844C1.60996 18.8281 1.17188 18.39 1.17188 17.8516V2.14844C1.17188 1.60996 1.60996 1.17188 2.14844 1.17188H7.8125V18.8281ZM18.8281 17.8516C18.8281 18.39 18.39 18.8281 17.8516 18.8281H8.98438V10.5859H15.5776L14.6248 11.5388C14.3959 11.7676 14.3959 12.1386 14.6248 12.3674C14.8536 12.5962 15.2246 12.5962 15.4534 12.3674L17.4065 10.4143C17.6354 10.1855 17.6354 9.81449 17.4065 9.58566L15.4534 7.63254C15.2246 7.40371 14.8536 7.40371 14.6248 7.63254C14.3959 7.86137 14.3959 8.23234 14.6248 8.46117L15.5776 9.41406H8.98438V1.17188H17.8516C18.39 1.17188 18.8281 1.60996 18.8281 2.14844V17.8516Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.803e438e1782a967b8393565628ff66b.svg";
export { ForwardRef as ReactComponent };